import type { Infer } from 'superstruct';
import {
	array,
	assign,
	number,
	object,
	optional,
	partial,
	string,
} from 'superstruct';

import {
	ViewFacebookAdCreativeMediaTemplateDto,
	ViewFacebookAdCreativeTemplateDto,
} from '@adflow/shared/data-facebook-ads';
import { stringDate } from '@adflow/shared/util-superstruct';

import { historyArrayItem } from '../history-array-item';

export const HistoryFacebookAdCreativeTemplateDto = assign(
	partial(ViewFacebookAdCreativeTemplateDto),
	partial(
		object({
			adCreativeMediaTemplates: array(
				historyArrayItem(partial(ViewFacebookAdCreativeMediaTemplateDto))
			),
			adCreatives: array(
				historyArrayItem(
					object({
						id: number(),
						facebookId: string(),
						syncedAt: stringDate(),
					})
				)
			),
			// Only used to distinguish ad sets on UI
			adCreativeTemplateName: optional(string()),
		})
	)
);

export type HistoryFacebookAdCreativeTemplateDto = Infer<
	typeof HistoryFacebookAdCreativeTemplateDto
>;
